import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PostcodesComponent } from './postcodes.component';
import { OpenPostcodesResolver } from './resolvers/open-postcodes.resolver';
import { OpenPostcodesComponent } from './open-postcodes/open-postcodes.component';

const routes: Routes = [
	{
		path: 'without/distributors',
		data: {title: 'Niet toegewezen postcodes', breadcrumb: 'Niet toegewezen postcodes'},
		component: OpenPostcodesComponent,
		resolve: {postcodes: OpenPostcodesResolver}
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
	providers: []
})

export class PostcodesRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/postcodes/postcodes-routing.module.ts